module.exports = __webpack_public_path__ + "img/banner_3.29884563.jpg";